import * as actionTypes from "./ActionTypes";

export const setCurrentPlanIdAction = (planId) => {
  return { type: actionTypes.SET_CURRENT_PLAN_ID, planId };
};

export const clearStateAction = (state) => {
  return { type: actionTypes.CLEAR_STATE, state };
};

export const WSConnectionAction = () => {
  return { type: actionTypes.WEBSOCKET_CONNECTION };
};
export const WSConnectionSuccessAction = (socketResponse) => {
  return { type: actionTypes.WEBSOCKET_CONNECTION_SUCCESS, socketResponse };
};
export const WSConnectionErrorAction = (err) => {
  return { type: actionTypes.WEBSOCKET_CONNECTION_ERROR, err };
};

export const MQTTConnectionAction = () => {
  return { type: actionTypes.MQTT_CONNECTION };
};
export const MQTTConnectionSuccessAction = (mqttResponse) => {
  return { type: actionTypes.MQTT_CONNECTION_SUCCESS, mqttResponse };
};
export const MQTTConnectionErrorAction = (err) => {
  return { type: actionTypes.MQTT_CONNECTION_ERROR, err };
};
